/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：385
 */

module.exports = {
  cloudDBPublishDialog: "styles_cloudDBPublishDialog__36Gy2",
  container: "styles_container__5dZt7",
  jump: "styles_jump__3PwdE",
  imgArea: "styles_imgArea__3aVYZ",
  textArea: "styles_textArea__EddL-",
  yellow: "styles_yellow__pLoIw",
  blue: "styles_blue__1CqT-",
  purple: "styles_purple__iMIQ8",
  orderArea: "styles_orderArea__GbwLV",
  round: "styles_round__z56ci",
  selected: "styles_selected__FDCES"
}
